import React from 'react'

const Items = (props) => {
  return (
    <div className={ props.className }>
      { props.children }
    </div>
  )
}

export default Items



// WEBPACK FOOTER //
// ./app/javascript/app/site/components/content/list/items/index.js